import type Player from 'video.js/dist/types/player';

// allows us to supply clips VideoPlayerRef or entire VideoPlayer
interface VideoPlayer {
  duration: Player['duration'];
  currentTime: Player['currentTime'];
  pause: Player['pause'];
  play: Player['play'] | (() => void | Promise<any> | undefined);
  trigger: Player['trigger'];
}

const isValidValue = (value?: number | null): value is number => value !== null && value !== undefined;

export const getSyncPlayerOnTimeUpdate = ({
  player,
  trimmedDurationSeconds,
  trimmedStartTimeSeconds,
}: {
  player: VideoPlayer | null;
  trimmedDurationSeconds?: number | null;
  trimmedStartTimeSeconds?: number | null;
}) => {
  return () => {
    const currentTime = player?.currentTime();
    const playerDuration = player?.duration();
    if (!player || !isValidValue(currentTime) || !isValidValue(playerDuration)) {
      return;
    }

    const start = trimmedStartTimeSeconds ?? 0;
    const end = trimmedDurationSeconds ? Math.floor(start + trimmedDurationSeconds) : playerDuration;

    if (currentTime < start) {
      player.currentTime(start);
    } else if (currentTime > end) {
      player.pause();
      player.trigger('ended');
    }
  };
};

export const syncPlayerDuration = (player: VideoPlayer | null, duration?: number | null) => {
  if (player && duration) {
    player.duration(duration);
  }
};
